import { render, staticRenderFns } from "./infoBox.vue?vue&type=template&id=4832ec7f&scoped=true&"
import script from "./infoBox.vue?vue&type=script&lang=js&"
export * from "./infoBox.vue?vue&type=script&lang=js&"
import style0 from "./infoBox.vue?vue&type=style&index=0&id=4832ec7f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4832ec7f",
  null
  
)

export default component.exports